var map = {
	"./template.betgalaxy": 1077,
	"./template.betgalaxy.tsx": 1077,
	"./template.betprofessor": 2064,
	"./template.betprofessor.tsx": 2064,
	"./template.default": 409,
	"./template.default.tsx": 409,
	"./template.forsport": 1078,
	"./template.forsport.tsx": 1078,
	"./template.puntgenie": 2065,
	"./template.puntgenie.tsx": 2065,
	"./template.ts": 966,
	"./template.wellbet": 1990,
	"./template.wellbet.tsx": 1990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2421;